module.exports = __webpack_public_path__ + "static/img/sample-img.cd07554.png";